import React, { useEffect, useState } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import './Acccount.css'
import axios from 'axios'
import { getAPIUrl, getAuthToken } from '../../script/util'
import { Toast } from '@egreact/shared'

const Acccount = () => {
  const [authDict, setAuthDict] = useState({})

  const [profileForm, setProfileForm] = useState({
    name: '',
    city: '',
  })

  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  useEffect(() => {
    try {
      const parsed = JSON.parse(localStorage.getItem('auth_dict') || '{}')
      setAuthDict(parsed || {})
    } catch (e) {
      setAuthDict({})
    }
  }, [])

  useEffect(() => {
    setProfileForm({
      name: authDict.eventGraphiaName || '',
      city: authDict.eventGraphiaCity || '',
    })
  }, [authDict])

  const handleUpdateProfile = (e) => {
    e.preventDefault()
    setError('')
    setSuccess('')

    const name = (profileForm.name || '').trim()
    const city = (profileForm.city || '').trim()

    if (!name) return setError('Please enter your name.')

    axios({
      method: 'post',
      url: getAPIUrl('/api/users/update_profile/'),
      headers: {
        Authorization: getAuthToken(),
        'Content-Type': 'application/json; charset=utf-8',
      },
      data: JSON.stringify({
        user_city: city,
        name,
      }),
    })
      .then((uppr) => {
        const body = uppr?.data
        if (body?.success === true) {
          const nextAuthDict = { ...authDict }
          nextAuthDict.eventGraphiaCity = city ? city.toLowerCase() : ''
          nextAuthDict.eventGraphiaName = name
          localStorage.setItem('auth_dict', JSON.stringify(nextAuthDict))
          setAuthDict(nextAuthDict)
          setSuccess(body?.message || 'Profile updated successfully.')
        } else {
          setError(body?.message || 'Failed to update profile.')
        }
      })
      .catch((err) => {
        setError(err?.response?.data?.message || 'Failed to connect to the server.')
      })
  }

  const email = authDict.eventGraphiaEmail || ''
  const phone = authDict.eventGraphiaPhone || ''

  return (
    <div className="account-page">
      <Navbar title={'Account'} />

      <div className="account-content">
        <section id="acc-c">
          <div id="acc-form">
            <h1 className="accountDetailHead">Account Details</h1>

            <form onSubmit={handleUpdateProfile}>
              <div className="form-el">
                <label htmlFor="usr-name">Name</label>
                <input
                  type="text"
                  id="usr-name"
                  value={profileForm.name}
                  placeholder="Your Name"
                  onChange={(e) => setProfileForm((p) => ({ ...p, name: e.target.value }))}
                />
              </div>

              <div className="form-el">
                <label htmlFor="usr-email">Email</label>
                <input
                  type="text"
                  id="usr-email"
                  value={email}
                  placeholder="Your Email ID"
                  disabled
                  readOnly
                />
              </div>

              <div className="form-el">
                <label htmlFor="usr-phn">Phone</label>
                <input
                  type="text"
                  id="usr-phn"
                  value={phone}
                  placeholder="Your Number"
                  disabled
                  readOnly
                />
              </div>

              <div className="form-el">
                <label htmlFor="usr-loc">City</label>
                <input
                  type="text"
                  id="usr-loc"
                  value={profileForm.city}
                  placeholder="Your City"
                  onChange={(e) => setProfileForm((p) => ({ ...p, city: e.target.value }))}
                />
              </div>

              <div className="form-el">
                <button type="submit" id="update-profile" className="book-prc-btn">
                  Update
                </button>
              </div>

              {error && (
                <div className="acc-message" role="alert">
                  <div className="acc-error">{error}</div>
                </div>
              )}
              {success && <Toast message={success} duration={3000} onClose={() => setSuccess('')} />}
            </form>
          </div>
        </section>

      </div>
    </div>
  )
}

export default Acccount